module.exports = __webpack_public_path__ + "img/badge-communication-gold-brightbg.42b5a8a8.svg";